import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-i-invested-standard-list" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconInvestedRounded = _resolveComponent("IconInvestedRounded")!
  const _component_IInvestedStandardListPanel = _resolveComponent("IInvestedStandardListPanel")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investedStandardHeadingArray, ({ indexKey, heading, iconComponent }, key) => {
      return (_openBlock(), _createElementBlock("li", {
        key: key,
        class: _normalizeClass(["p-i-invested-standard-list__item", `p-i-invested-standard-list__item--${key + 1}`])
      }, [
        (
          _ctx.investedStandardDetail.length > 0 &&
          !(
            (_ctx.investedStandardDetail[0]['kind'] == 10 ||
              _ctx.investedStandardDetail[0]['kind'] == 50) &&
            indexKey == 'kind'
          )
        )
          ? (_openBlock(), _createBlock(_component_IInvestedStandardListPanel, { key: 0 }, _createSlots({
              heading: _withCtx(() => [
                _createTextVNode(_toDisplayString(heading), 1)
              ]),
              _: 2
            }, [
              iconComponent
                ? {
                    name: "content",
                    fn: _withCtx(() => [
                      _createVNode(_component_IconInvestedRounded, {
                        type: _ctx.investedStandardDetailItem[indexKey],
                        "icon-size": 48,
                        "bg-color": _ctx.colorCode
                      }, null, 8, ["type", "bg-color"])
                    ]),
                    key: "0"
                  }
                : {
                    name: "content",
                    fn: _withCtx(() => [
                      (indexKey == 'kind')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.investedStandardDetailItem[indexKey]), 1))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            "data-translate-skip": "",
                            class: _normalizeClass({
              'p-i-invested-standard-list__text': indexKey === 'text'
            })
                          }, _toDisplayString(_ctx.investedStandardDetailItem[indexKey]), 3))
                    ]),
                    key: "1"
                  }
            ]), 1024))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}